<div class="content">
    <img src="../assets/images/NWMO-Invalid.svg" />
    <h1>Looks like something went wrong.</h1>
    <h3>If this continues to happen, please contact <a href="mailto:NWMOpensions@eckler.ca">NWMOpensions@eckler.ca</a>.</h3>
  </div>
  
